import type { DailySalesReport } from '../../../../api/daily-sales';
import { includesAny, RETAIL_SOURCES } from '../daily-sales-filters';
import { easternTime, longDate, shortDate, type SourceKey } from '../daily-sales-format';

interface DailySalesFreshnessProps {
  report: DailySalesReport;
  sources: SourceKey[];
}

export function DailySalesFreshness({ report, sources }: DailySalesFreshnessProps) {
  const latest = (source: string, at: string | null) =>
    at ? `latest ${source} sale ${easternTime(at)}` : `no ${source} sales in this window`;
  const lines = [
    includesAny(sources, ['fareharbor', 'giftCards']) &&
      latest('FareHarbor', report.fareharborLatestSale),
    sources.includes('nebari') && latest('Nebari', report.nebariLatestSale),
    sources.includes('giftPasses') && latest('gift pass', report.giftPassLatestSale),
    includesAny(sources, RETAIL_SOURCES) && latest('retail', report.retailLatestSale),
  ].filter(Boolean);

  return (
    <div className="nb-ds-meta">
      {shortDate(report.from)} – {longDate(report.to)} · Built {easternTime(report.generatedAt)}
      {report.to === report.today && lines.length > 0 && (
        <>
          <br />
          {lines.join(' · ')}
        </>
      )}
    </div>
  );
}
